import { useState } from "react";
import { GlassCard, TranslationBubble } from "@kj/design-system";
import { Send } from "lucide-react";

type Msg = {
  id: string;
  role: "self" | "other";
  original: string;
  translated: string;
  sourceLang: "ko" | "ja";
  targetLang: "ko" | "ja";
  confidence: number;
  formality: "polite" | "casual";
  ts: string;
};

const seed: Msg[] = [
  {
    id: "1",
    role: "other",
    original: "こんにちは、はじめまして！お会いできて嬉しいです。",
    translated: "안녕하세요, 처음 뵙겠습니다! 만나서 반가워요.",
    sourceLang: "ja",
    targetLang: "ko",
    confidence: 0.96,
    formality: "polite",
    ts: "오후 8:12",
  },
  {
    id: "2",
    role: "self",
    original: "안녕하세요 미유님! 프로필에서 Stray Kids 좋아하시는 거 봤어요.",
    translated:
      "こんにちは、みゆさん！プロフィールで Stray Kids がお好きだと拝見しました。",
    sourceLang: "ko",
    targetLang: "ja",
    confidence: 0.93,
    formality: "polite",
    ts: "오후 8:13",
  },
];

export default function ChatPage() {
  const [messages, setMessages] = useState<Msg[]>(seed);
  const [input, setInput] = useState("");

  const send = () => {
    if (!input.trim()) return;
    // TODO: Sprint 1에서 실 API 연동 (POST /v1/messages → Gemma 4 번역)
    const demo: Msg = {
      id: crypto.randomUUID(),
      role: "self",
      original: input,
      translated: "（モック訳）" + input,
      sourceLang: "ko",
      targetLang: "ja",
      confidence: 0.88,
      formality: "polite",
      ts: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
    };
    setMessages((prev) => [...prev, demo]);
    setInput("");
  };

  return (
    <div className="flex h-[calc(100vh-12rem)] min-h-[480px] flex-col gap-3">
      <header className="flex items-center justify-between px-2">
        <div>
          <h2 className="text-lg font-semibold">미유 / Miyu</h2>
          <p className="text-xs text-fg-muted">
            실시간 통역 · 존댓말 · 잔여 58:42
          </p>
        </div>
        <div className="text-xs text-fg-muted">BLEU 신뢰도 자동 표시</div>
      </header>

      <GlassCard radius="xl" padding="sm" className="flex-1 overflow-y-auto">
        <div className="flex flex-col gap-3">
          {messages.map((m) => (
            <TranslationBubble
              key={m.id}
              role={m.role}
              original={m.original}
              translated={m.translated}
              sourceLang={m.sourceLang}
              targetLang={m.targetLang}
              confidence={m.confidence}
              formality={m.formality}
              timestamp={m.ts}
            />
          ))}
        </div>
      </GlassCard>

      <GlassCard radius="xl" padding="sm">
        <form
          className="flex items-center gap-2"
          onSubmit={(e) => {
            e.preventDefault();
            send();
          }}
        >
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="한국어로 메시지를 입력하세요…"
            aria-label="메시지 입력"
            className="min-w-0 flex-1 bg-transparent px-3 py-2 text-sm outline-none placeholder:text-fg-muted"
          />
          <button
            type="submit"
            className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-white shadow-glass-sm disabled:opacity-50"
            disabled={!input.trim()}
          >
            <Send className="h-4 w-4" aria-hidden="true" />
            보내기
          </button>
        </form>
      </GlassCard>
    </div>
  );
}
